import { handleErrorApi } from "../../helpers/randoms";
import ComunicacionConEmpresasService from "../../services/ComunicacionConEmpresasService";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

const baseUrl = process.env.REACT_APP_API_URL;

export const getDocumentacionComunicacionPorCuit = (cuit) => async (dispatch) => {
    try {
        const response = await ComunicacionConEmpresasService.TraeDocumentacionPorCuit(cuit);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.getDocumentacionPorCuitEmpresaSuccess,
                payload: body
            });
        }
    } catch (error) {
        handleErrorApi(
            dispatch,
            error,
            "Error al obtener documentación",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }
}

export const fileUploadDocuComunicacion =(file, cuit) => async (dispatch)=> {
        const url = `${baseUrl}/Documentacion_ComunicacionConEmpresas/NuevaDocu/${cuit}`;
        const token = localStorage.getItem('token') || sessionStorage.getItem('token') || '';
        let httpHeaders;
        if (token) {
          httpHeaders = {
            Authorization: `Bearer ${token}`,
          };
        }
        const formData = new FormData();
        formData.append("files", file);
        try {
          const resp = await fetch(url, {
            method: "POST",
            body: formData,
            headers: httpHeaders
          });
          const respCloud = await resp.json();
          if (resp.ok) {
            dispatch(getDocumentacionComunicacionPorCuit(cuit));
            dispatch(finishSpinner());
            dispatch(
                startAlerta(
                  "Datos Guardados Exitosamente",
                  "success",
                  "Comando Exitoso"
                )
              );
          } else {
            throw respCloud;
      
          }
        } catch (error) {
          console.log("Function [fileUpload]", error);
        }
      };

      export const DeleteDocumentacionComunicacion = (idDocumentacion, cuit) => async (dispatch) => {
        dispatch(startSpinner());
        try{
            const response = await ComunicacionConEmpresasService.EliminarDocumentacion(idDocumentacion); 
            const body = await response.json();
            if(response.ok){
                dispatch(
                    startAlerta(
                        "Documento Eliminado Exitosamente",
                        "success",
                        "Comando Exitoso"
                    )
                )
                dispatch(getDocumentacionComunicacionPorCuit(cuit));
                dispatch(finishSpinner());
            }else{
                throw body;
            }
        }catch(error){
            dispatch(finishSpinner());
            handleErrorApi(
                dispatch,
                error,
                "Error al eliminar el documento.",
                "Ha ocurrido un error. Intente nuevamente."
              );
        }
    };
      